import { render, staticRenderFns } from "./LandPage.vue?vue&type=template&id=cb99b00a"
import script from "./LandPage.vue?vue&type=script&lang=js"
export * from "./LandPage.vue?vue&type=script&lang=js"
import style0 from "./LandPage.vue?vue&type=style&index=0&id=cb99b00a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports